// AUTO-GENERATED — do not edit.
// Lean web projection of intent_offer_alignment.yaml; no domain-data runtime import.
// Regenerate: uv run python execution/generate_intent_offer_ts.py

export const SEO_PRIMARY_REPORT_OFFERS = {
  baby_name: "baby_name_report",
  birth_chart: "brihat_kundali",
  career: "career_report",
  dosha_remedy: "dosha_remedy_plan",
  festival_ritual: "muhurat_report",
  forecast: "annual_forecast",
  gemstone: "gemstone_report",
  gochar: "transit_forecast",
  lal_kitab: "lal_kitab_report",
  mahadasha_forecast: "mahadasha_forecast",
  matching: "marriage_report",
  numerology: "numerology_report",
  pitra_dosh_report: "pitra_dosh",
  sade_sati_report: "sade_sati",
  timing: "muhurat_report",
} as const;

export type GovernedSEOReportIntent = keyof typeof SEO_PRIMARY_REPORT_OFFERS;
export type GovernedSEOReportPlanId = (typeof SEO_PRIMARY_REPORT_OFFERS)[GovernedSEOReportIntent];

export const SEO_POST_PURCHASE_REPORT_OFFERS = {
  annual_forecast: "brihat_kundali",
  baby_name_report: "brihat_kundali",
  brihat_kundali: "annual_forecast",
  career_report: "brihat_kundali",
  dosha_remedy_plan: "brihat_kundali",
  gemstone_report: "brihat_kundali",
  lal_kitab_report: "brihat_kundali",
  mahadasha_forecast: "brihat_kundali",
  marriage_report: "brihat_kundali",
  muhurat_report: "brihat_kundali",
  numerology_report: "brihat_kundali",
  pitra_dosh: "brihat_kundali",
  sade_sati: "brihat_kundali",
  transit_forecast: "brihat_kundali",
} as const;

export type GovernedPostPurchaseReportSourcePlanId = keyof typeof SEO_POST_PURCHASE_REPORT_OFFERS;
export type GovernedPostPurchaseReportTargetPlanId =
  (typeof SEO_POST_PURCHASE_REPORT_OFFERS)[GovernedPostPurchaseReportSourcePlanId];

export const SEO_REPORT_PLAN_IDS = {
  annual_forecast: "annual_forecast",
  baby_name_report: "baby_name_report",
  brihat_kundali: "brihat_kundali",
  career_report: "career_report",
  dosha_remedy_plan: "dosha_remedy_plan",
  gemstone_report: "gemstone_report",
  lal_kitab_report: "lal_kitab_report",
  mahadasha_forecast: "mahadasha_forecast",
  marriage_report: "marriage_report",
  muhurat_report: "muhurat_report",
  numerology_report: "numerology_report",
  pitra_dosh: "pitra_dosh",
  sade_sati: "sade_sati",
  transit_forecast: "transit_forecast",
} as const;
